module.exports = __webpack_public_path__ + "img/20.24f58ce8.jpg";